import React from 'react'
import {
  DcDiv,
  DcDropDown,
  DcFlexBox,
  DcInput,
  DcSwitch,
  DcText,
  PixelButton,
  PixelFactoryContext,
  PixelText,
  SectionContent,
} from 'pixel-base'
import styled from 'styled-components'

import { addNewCustomer, getCountryStates } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl'

const AddNewCustomer = (props) => {
  const { setIsCustomerAdd, countries, handleClose } = props
  const [data, setData] = React.useState({
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    company: '',
    customer_reference: '',
    address: {
      first_name: '',
      last_name: '',
      phone: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      is_default: true,
      alternative_phone: '',
      fax: '',
      country: countries?.default,
      address_type: 'billing',
    },
  })
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [addAddress, setAddAddress] = React.useState(
    props.isItInvoice ? true : false,
  )
  const [states, setStates] = React.useState([])

  React.useEffect(() => {
    getCountryStates(data.address.country).subscribe((res: any) => {
      setStates(res.response.data)
    })
  }, [data.address.country])
  const newCustomer = () => {
    showPageLoader()
    const payload = {
      ...data,
    }
    if (addAddress) {
      payload.address.first_name = payload.first_name
      payload.address.last_name = payload.last_name
      payload.address.phone = payload.phone
    } else {
      delete payload.address
    }

    addNewCustomer(payload).subscribe((res: any) => {
      hidePageLoader()

      if (res.response.data) {
        showSuccess('Successfully Created')

        handleClose(res.response.data)
        setIsCustomerAdd(true)
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    newCustomer()
  }
  return (
    <Form onSubmit={handleSubmit}>
      <PixelText>Primary Contact:</PixelText>
      <FormGroup>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '16px',

            textAlign: 'left',
          }}
        >
          <DcText
            fontSize=".875rem"
            fontWeight="500"
            customColor="#2e314a"
            style={{
              textAlign: 'left',
              margin: '0 0 0.5rem 0',
            }}
          >
            First Name
          </DcText>
          <DcInput
            error={
              error.field === 'first_name' && error.error !== ''
                ? error.error
                : null
            }
            required
            type={'text'}
            name={'First Name'}
            placeholder={'First Name *'}
            value={data.first_name}
            onChange={(e) => setData({ ...data, first_name: e.target.value })}
          />
        </DcDiv>

        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '16px',

            textAlign: 'left',
          }}
        >
          <DcText
            fontSize=".875rem"
            fontWeight="500"
            customColor="#2e314a"
            style={{
              textAlign: 'left',
              margin: '0 0 0.5rem 0',
            }}
          >
            Last Name
          </DcText>
          <DcInput
            error={
              error.field === 'last_name' && error.error !== ''
                ? error.error
                : null
            }
            required
            type={'text'}
            name={'Last Name'}
            placeholder={'Last Name *'}
            value={data.last_name}
            onChange={(e) => setData({ ...data, last_name: e.target.value })}
          />
        </DcDiv>
      </FormGroup>
      <FormGroup>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '16px',

            textAlign: 'left',
          }}
        >
          <DcText
            fontSize=".875rem"
            fontWeight="500"
            customColor="#2e314a"
            style={{
              textAlign: 'left',
              margin: '0 0 0.5rem 0',
            }}
          >
            Contact Number
          </DcText>
          <DcInput
            error={
              error.field === 'phone' && error.error !== '' ? error.error : null
            }
            required
            type={'text'}
            name={'Name'}
            placeholder={'Contact Number *'}
            value={data.phone}
            onChange={(e) => setData({ ...data, phone: e.target.value })}
          />
        </DcDiv>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '16px',

            textAlign: 'left',
          }}
        >
          <DcText
            fontSize=".875rem"
            fontWeight="500"
            customColor="#2e314a"
            style={{
              textAlign: 'left',
              margin: '0 0 0.5rem 0',
            }}
          >
            Email
          </DcText>
          <DcInput
            error={
              error.field === 'email' && error.error !== '' ? error.error : null
            }
            type={'text'}
            name={'email'}
            placeholder={'Email'}
            value={data.email}
            onChange={(e) => setData({ ...data, email: e.target.value })}
          />
        </DcDiv>
      </FormGroup>
      <FormGroup>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '16px',

            textAlign: 'left',
          }}
        >
          <DcText
            fontSize=".875rem"
            fontWeight="500"
            customColor="#2e314a"
            style={{
              textAlign: 'left',
              margin: '0 0 0.5rem 0',
            }}
          >
            Company Name
          </DcText>
          <DcInput
            error={
              error.field === 'company' && error.error !== ''
                ? error.error
                : null
            }
            type={'text'}
            name={'Company'}
            placeholder={'Company Name'}
            value={data.company}
            onChange={(e) => setData({ ...data, company: e.target.value })}
          />
        </DcDiv>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '16px',

            textAlign: 'left',
          }}
        >
          <DcText
            fontSize=".875rem"
            fontWeight="500"
            customColor="#2e314a"
            style={{
              textAlign: 'left',
              margin: '0 0 0.5rem 0',
            }}
          >
            Ref #
          </DcText>
          <DcInput
            error={
              error.field === 'customer_reference' && error.error !== ''
                ? error.error
                : null
            }
            type={'text'}
            name={'Ref #'}
            placeholder={'Ref #'}
            value={data.customer_reference}
            onChange={(e) =>
              setData({ ...data, customer_reference: e.target.value })
            }
          />
        </DcDiv>
      </FormGroup>
      <FormGroup>
        <DcFlexBox
          padding="10px"
          height="auto"
          style={{ width: '100%' }}
          justifyContent="flex-start"
          alignItems="center"
          gap="10px "
        >
          <DcFlexBox height="auto" style={{ width: '135px' }}>
            Add address?
          </DcFlexBox>
          <DcSwitch
            onChange={(e) => {
              setAddAddress(e.target.checked)
            }}
            checked={addAddress}
            label={addAddress ? 'Yes' : 'No'}
          />
        </DcFlexBox>
      </FormGroup>
      {addAddress && (
        <>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '16px',

                textAlign: 'left',
              }}
            >
              <DcText
                fontSize=".875rem"
                fontWeight="500"
                customColor="#2e314a"
                style={{
                  textAlign: 'left',
                  margin: '0 0 0.5rem 0',
                }}
              >
                Address Line 1
              </DcText>
              <DcInput
                // error={
                //   error.field === 'address1' && error.error !== ''
                //     ? error.error
                //     : null
                // }
                required
                type={'text'}
                name={'address1'}
                placeholder={'Address Line 1 *'}
                value={data.address.address1}
                onChange={(e) =>
                  setData({
                    ...data,
                    address: { ...data.address, address1: e.target.value },
                  })
                }
              />
            </DcDiv>
          </FormGroup>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '16px',

                textAlign: 'left',
              }}
            >
              <DcText
                fontSize=".875rem"
                fontWeight="500"
                customColor="#2e314a"
                style={{
                  textAlign: 'left',
                  margin: '0 0 0.5rem 0',
                }}
              >
                Address Line 2
              </DcText>
              <DcInput
                // error={
                //   error.field === 'address2' && error.error !== ''
                //     ? error.error
                //     : null
                // }
                type={'text'}
                name={'address2'}
                placeholder={'Address Line 2'}
                value={data.address.address2}
                onChange={(e) =>
                  setData({
                    ...data,
                    address: { ...data.address, address2: e.target.value },
                  })
                }
              />
            </DcDiv>
          </FormGroup>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '16px',

                textAlign: 'left',
              }}
            >
              <DcText
                fontSize=".875rem"
                fontWeight="500"
                customColor="#2e314a"
                style={{
                  textAlign: 'left',
                  margin: '0 0 0.5rem 0',
                }}
              >
                Alternative Phone
              </DcText>
              <DcInput
                // error={
                //   error.field === 'alternative_phone' && error.error !== ''
                //     ? error.error
                //     : null
                // }
                type={'text'}
                name={'alternative_phone'}
                placeholder={'Alternative Phone'}
                value={data.address.alternative_phone}
                onChange={(e) =>
                  setData({
                    ...data,
                    address: {
                      ...data.address,
                      alternative_phone: e.target.value,
                    },
                  })
                }
              />
            </DcDiv>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '16px',

                textAlign: 'left',
              }}
            >
              <DcText
                fontSize=".875rem"
                fontWeight="500"
                customColor="#2e314a"
                style={{
                  textAlign: 'left',
                  margin: '0 0 0.5rem 0',
                }}
              >
                Fax
              </DcText>
              <DcInput
                error={
                  error.field === 'fax' && error.error !== ''
                    ? error.error
                    : null
                }
                type={'text'}
                name={'fax'}
                placeholder={'Fax'}
                value={data.address.fax}
                onChange={(e) =>
                  setData({
                    ...data,
                    address: { ...data.address, fax: e.target.value },
                  })
                }
              />
            </DcDiv>
          </FormGroup>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '16px',

                textAlign: 'left',
              }}
            >
              <DcText
                fontSize=".875rem"
                fontWeight="500"
                customColor="#2e314a"
                style={{
                  textAlign: 'left',
                  margin: '0 0 0.5rem 0',
                }}
              >
                Select Country
              </DcText>
              <DcDropDown
                error={
                  error.field === 'country' && error.error !== ''
                    ? error.error
                    : null
                }
                placeholder={'Select Country *'}
                options={countries?.list.map((p) => {
                  return {
                    label: p?.name,
                    value: p?.two_letter_abbreviation,
                  }
                })}
                value={data?.address?.country}
                onChange={(e) => {
                  setData({
                    ...data,
                    address: { ...data.address, country: e.target.value },
                  })
                }}
              />
            </DcDiv>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '16px',

                textAlign: 'left',
              }}
            >
              <DcText
                fontSize=".875rem"
                fontWeight="500"
                customColor="#2e314a"
                style={{
                  textAlign: 'left',
                  margin: '0 0 0.5rem 0',
                }}
              >
                Select State
              </DcText>
              <DcDropDown
                error={
                  error.field === 'state' && error.error !== ''
                    ? error.error
                    : null
                }
                placeholder={'Select State *'}
                options={[
                  {
                    name: 'Select State',
                    code: '',
                  },
                  ...states,
                ].map((p) => {
                  return {
                    label: p.name,
                    value: p.code,
                  }
                })}
                value={data.address.state}
                onChange={(e) => {
                  setData({
                    ...data,
                    address: { ...data.address, state: e.target.value },
                  })
                }}
              />
            </DcDiv>
          </FormGroup>
          <FormGroup>
            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '16px',

                textAlign: 'left',
              }}
            >
              <DcText
                fontSize=".875rem"
                fontWeight="500"
                customColor="#2e314a"
                style={{
                  textAlign: 'left',
                  margin: '0 0 0.5rem 0',
                }}
              >
                City
              </DcText>
              <DcInput
                error={
                  error.field === 'city' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                type={'text'}
                name={'city'}
                placeholder={'City *'}
                value={data.address.city}
                onChange={(e) =>
                  setData({
                    ...data,
                    address: { ...data.address, city: e.target.value },
                  })
                }
              />
            </DcDiv>

            <DcDiv
              width="100%"
              height="auto"
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '16px',

                textAlign: 'left',
              }}
            >
              <DcText
                fontSize=".875rem"
                fontWeight="500"
                customColor="#2e314a"
                style={{
                  textAlign: 'left',
                  margin: '0 0 0.5rem 0',
                }}
              >
                Zip Code
              </DcText>
              <DcInput
                error={
                  error.field === 'zip' && error.error !== ''
                    ? error.error
                    : null
                }
                required
                // parentStyle={{
                //   width: "50%",
                // }}
                type={'text'}
                name={'zip'}
                placeholder={'Zip Code *'}
                value={data.address.zip}
                onChange={(e) =>
                  setData({
                    ...data,
                    address: { ...data.address, zip: e.target.value },
                  })
                }
              />
            </DcDiv>
          </FormGroup>
        </>
      )}
      <FormGroup style={{ padding: '10px' }} flexEnd>
        <PixelButton type={'submit'}>Create</PixelButton>
      </FormGroup>
    </Form>
  )
}
const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  /* gap: 10px; */
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  /* padding: 10px; */
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
export default AddNewCustomer
